import { render, staticRenderFns } from "./healthPlatformReport.vue?vue&type=template&id=f9a84bbc&scoped=true"
import script from "./healthPlatformReport.vue?vue&type=script&lang=js"
export * from "./healthPlatformReport.vue?vue&type=script&lang=js"
import style0 from "./healthPlatformReport.vue?vue&type=style&index=0&id=f9a84bbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a84bbc",
  null
  
)

export default component.exports